<dialog
  #dialog
  qai-dialog
  [heading]="simulationName"
  (afterClose)="handleClose()"
>
  <div class="container">
    <qai-tabs>
      <ng-template *ngIf="tabs[0]?.content" qaiTab="overview" [label]="tabs[0].label">
        <div class="content" [style.max-height]="contentMaxHeight" [innerHTML]="tabs[0].content | processMarkdown"></div>
      </ng-template>

      <ng-template
        *ngIf="tabs[1]?.content"
        qaiTab="persona"
        [label]="tabs[1].label"
      >
        <div class="content" [style.max-height]="contentMaxHeight" [innerHTML]="tabs[1].content | processMarkdown"></div>
      </ng-template>

      <ng-template
        *ngIf="tabs[2]?.content"
        qaiTab="criteria"
        [label]="tabs[2].label"
      >
        <div class="content" [style.max-height]="contentMaxHeight" [innerHTML]="tabs[2].content | processMarkdown"></div>
      </ng-template>

      <ng-template
        *ngIf="tabs[3]?.content && tabs[3]?.label"
        qaiTab="additional"
        [label]="tabs[3].label"
      >
        <div class="content" [style.max-height]="contentMaxHeight" [innerHTML]="tabs[3].content | processMarkdown"></div>
      </ng-template>
    </qai-tabs>
  </div>
</dialog>
